{
  "documentCategory": {
    "memos": "Asukaskokouksen asiakirjat",
    "general": "Yleistä",
    "safety": "Turvallisuus"
  },
  "errors": {
    "failedToLoad": "Dokumenttien lataaminen epäonnistui",
    "failedToOpen": "Dokumentin avaaminen epäonnistui",
    "noDocuments": "Ei dokumentteja"
  }
}
